import type { ReactElement } from 'react';
import type { MascotFace } from '../../../../../shared/ember-mascot.js';
import { EmberMascot } from './EmberMascot';
import './EmberDisc.css';

/**
 * Ember's face on a small warm-paper disc — the picture the conversation
 * puts beside every one of Ember's turns (ConversationShell), lent to the
 * places that quote Ember's voice at picture scale: the homepage's drawn
 * bubbles and letters, a section title that is Ember's own summary. Pinned,
 * still, decorative: the words beside it carry the meaning (2026-09-14).
 */
export function EmberDisc({ face = 'listening', className = '' }: { face?: MascotFace; className?: string }): ReactElement {
  return (
    <span className={`ember-disc${className ? ` ${className}` : ''}`} aria-hidden>
      <EmberMascot face={face} still interactive={false} className="ember-disc-face" />
    </span>
  );
}
